/* Happy Monkfruit — sticky add-to-cart bar behaviour.
   Externalised from snippets/hmf-sticky-atc.liquid. The only Liquid value it
   needed was the section id, which now arrives as window.HMF_SAB_SID. */
(function(){
  // The `section` object is not in scope inside a rendered snippet, so the
  // section id is handed over as a parameter instead.
  var ROOT = document.getElementById('hmf-pdp-' + (window.HMF_SAB_SID || ''));
  var BAR  = document.querySelector('[data-hmf-sab]');
  if(!ROOT || !BAR || ROOT.dataset.hmfSabInit) return;
  ROOT.dataset.hmfSabInit = '1';

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var elBtn  = BAR.querySelector('[data-sab-atc]');
  var elName = BAR.querySelector('[data-sab-name]');
  var elSub  = BAR.querySelector('[data-sab-sub]');
  var elImg  = BAR.querySelector('[data-sab-img]');

  function realBtn(){ return ROOT.querySelector('[data-buybox] [data-atc]'); }
  function galleryImg(){
    var g = ROOT.querySelector('[data-gallery-stage] img');
    if(!g) return null;
    // A scrolled-past image still reports a full-size rect, so measuring width
    // alone would launch the fly from off screen. Require it to be on screen.
    var r = g.getBoundingClientRect();
    if(!r.width || !r.height) return null;
    if(r.bottom < 40 || r.top > window.innerHeight - 40) return null;
    return g;
  }

  /* ---- mirror the real buy box --------------------------------------- */
  var syncQueued = false;
  function queueSync(){
    if(syncQueued) return;
    syncQueued = true;
    // setTimeout rather than requestAnimationFrame: rAF is suspended while the
    // tab is in the background, which would freeze the mirror mid-state.
    setTimeout(function(){ syncQueued = false; sync(); }, 60);
  }
  function txt(sel){
    var n = ROOT.querySelector(sel);
    return n ? (n.textContent || '').trim() : '';
  }
  function sync(){
    var rb = realBtn();
    if(rb){
      // innerHTML, not textContent: this carries the checkmark markup through
      // so the bar shows the same "Added" state without re-implementing it.
      if(elBtn.innerHTML !== rb.innerHTML) elBtn.innerHTML = rb.innerHTML;
      elBtn.disabled = !!rb.disabled;
    }
    var name = txt('[data-buybox] h1');
    if(name && elName.textContent !== name) elName.textContent = name;

    var plan = txt('[data-buybox] .plan-blk > div:first-child').replace(/^Plan:\s*/i,'');
    var size = txt('[data-buybox] .price-blk > span:last-child');
    var sub  = [plan, size].filter(Boolean).join(' · ');
    if(elSub.textContent !== sub) elSub.textContent = sub;

    /* The bar's thumbnail is deliberately NOT the slide the shopper is looking
       at. Mirroring the stage meant the little card swapped picture every time
       they tapped a thumb or swiped the gallery, which reads as the bar
       changing product under them. It now always shows slide 0 — the pack shot
       — and only ever changes when the liquid/powder tab changes, which is
       exactly when the name and the price next to it change as well.
       Slide 0 is read out of the thumb row rather than the stage: the stage
       only ever holds the current slide, while the row always holds slide 0 at
       index 0, and at 260px it is a picture the browser has already fetched.
       The stage is used as a fallback only while the bar still has no image at
       all, so a missing thumb row cannot leave an empty square. */
    var f = ROOT.querySelector('[data-thumbrow] [data-thumb="0"] img')
         || (elImg.getAttribute('src') ? null : ROOT.querySelector('[data-gallery-stage] img'));
    var src = f ? (f.currentSrc || f.getAttribute('src') || '') : '';
    if(src && elImg.getAttribute('src') !== src) elImg.setAttribute('src', src);

    // The buy box arrives after this script runs, so re-measure whenever it
    // changes — that is what lets the bar be up already on page load.
    // tick() is a hoisted declaration, so calling it from here is safe.
    tick();
  }

  if(window.MutationObserver){
    var mo = new MutationObserver(queueSync);
    var bb = ROOT.querySelector('[data-buybox]');
    var gs = ROOT.querySelector('[data-gallery-stage]');
    // The thumb row is watched as well as the stage, because the bar's picture
    // now comes from the row. Switching the liquid/powder tab rebuilds both,
    // and that is the one moment the bar's picture is supposed to change.
    var tr = ROOT.querySelector('[data-thumbrow]');
    if(bb) mo.observe(bb, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['disabled']});
    if(gs) mo.observe(gs, {childList:true, subtree:true, attributes:true, attributeFilter:['src','srcset']});
    if(tr) mo.observe(tr, {childList:true, subtree:true, attributes:true, attributeFilter:['src','srcset']});
  }
  sync();

  /* ---- when to show it ------------------------------------------------
     Olipop's rule: the bar is up whenever the real Add to cart button is NOT
     visible, including on first paint, and it drops the moment that button
     scrolls into view. So the test is the real button's own rect, not the
     buy column's — on the phone the gallery pushes the button below the fold,
     so the bar is already up when the page lands.
     Measured on a scroll listener rather than with an IntersectionObserver:
     the first version put a 1px sentinel div after the Amazon button, but on
     this theme it lands inside a wrapper whose computed display is none, so
     it never had a box and the bar never appeared. Re-querying the button
     every tick also keeps working after renderBuybox() rebuilds the column. */
  var foot = document.querySelector('#hmf-newsletter') || document.querySelector('footer');

  function setOn(on){
    if((BAR.getAttribute('data-on') === 'true') === !!on) return;
    BAR.setAttribute('data-on', on ? 'true' : 'false');
    BAR.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  var pending = false;
  function measure(){
    pending = false;
    var rb = realBtn();
    // The buy box is rendered by JS, so on the very first pass there may be
    // nothing to mirror yet. Stay down; sync() ticks again once it exists.
    if(!rb){ setOn(false); return; }
    var vh = window.innerHeight || 0;
    var barH = BAR.offsetHeight || 70;
    var r = rb.getBoundingClientRect();
    // The bar is fixed to the bottom and ~70px tall, so a button peeking out
    // from underneath it is not actually visible to the shopper.
    var btnOnScreen = r.bottom > 0 && r.top < (vh - barH - 8);
    // Stand down before the newsletter block so the bar never covers it.
    var atFooter = foot ? foot.getBoundingClientRect().top < vh - 60 : false;
    setOn(!btnOnScreen && !atFooter);
  }
  function tick(){
    if(pending) return;
    pending = true;
    setTimeout(measure, 80);
  }
  window.addEventListener('scroll', tick, {passive:true});
  window.addEventListener('resize', tick);
  window.addEventListener('load', tick);
  tick();

  /* ---- forward the tap to the real button ---------------------------- */
  elBtn.addEventListener('click', function(){
    var rb = realBtn();
    if(rb && !rb.disabled) rb.click();
  });

  /* ---- motion --------------------------------------------------------- */
  var lastFx = 0, lastBtn = null;

  function wave(x, y, h){
    if(reduce) return;
    var d = Math.max(90, h * 2.6);
    var w = document.createElement('span');
    w.className = 'hmf-atc-wave';
    w.style.width = d + 'px';
    w.style.height = d + 'px';
    w.style.left = x + 'px';
    w.style.top = y + 'px';
    document.body.appendChild(w);
    setTimeout(function(){ if(w.parentNode) w.parentNode.removeChild(w); }, 620);
  }

  function fly(src){
    if(reduce || !src) return;
    var badge = document.querySelector('[data-cart-bubble]');
    var tgtEl = badge ? (badge.parentElement || badge) : null;
    if(!tgtEl) return;
    var s = src.getBoundingClientRect(), t = tgtEl.getBoundingClientRect();
    if(!s.width || !t.width) return;

    var size = Math.min(120, Math.max(48, s.width * 0.5));
    var g = document.createElement('div');
    g.className = 'hmf-atc-fly';
    g.style.width = size + 'px';
    g.style.height = size + 'px';
    var im = document.createElement('img');
    im.src = src.currentSrc || src.getAttribute('src') || '';
    im.alt = '';
    g.appendChild(im);
    if(!g.animate){ return; }
    document.body.appendChild(g);

    var sx = s.left + s.width / 2, sy = s.top + s.height / 2;
    var tx = t.left + t.width / 2, ty = t.top + t.height / 2;
    var mx = sx + (tx - sx) * 0.45;
    var my = Math.min(sy, ty) - Math.max(70, Math.abs(ty - sy) * 0.28);
    function T(x, y, k){
      return 'translate(' + (x - size / 2) + 'px,' + (y - size / 2) + 'px) scale(' + k + ')';
    }
    var an = g.animate([
      {transform:T(sx, sy, 1),   opacity:1,   offset:0},
      {transform:T(mx, my, .7),  opacity:1,   offset:.55},
      {transform:T(tx, ty, .16), opacity:.15, offset:1}
    ], {duration:520, easing:'cubic-bezier(.32,.06,.4,1)', fill:'forwards'});
    function done(){ if(g.parentNode) g.parentNode.removeChild(g); }
    an.onfinish = done;
    setTimeout(done, 950);
  }

  // One capture-phase listener covers both buttons. The sticky bar forwards its
  // tap by calling .click() on the real one, which would otherwise fire this
  // twice — hence the short dedupe window.
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-atc],[data-sab-atc]');
    if(!b || b.disabled) return;
    var now = (window.performance && performance.now) ? performance.now() : +new Date();
    if(now - lastFx < 300) return;
    lastFx = now;
    lastBtn = b;

    if(!reduce){
      b.classList.remove('hmf-atc-press');
      void b.offsetWidth;
      b.classList.add('hmf-atc-press');
      setTimeout(function(){ b.classList.remove('hmf-atc-press'); }, 320);

      var r = b.getBoundingClientRect();
      var cx = (e.clientX || r.left + r.width / 2);
      var cy = (e.clientY || r.top + r.height / 2);
      wave(cx, cy, r.height);

      // From whatever the shopper can actually see: the gallery when they are
      // still at the buy box, the bar's own thumbnail when they have scrolled on.
      fly(galleryImg() || elImg);
    }
  }, true);

  document.addEventListener('hmf:cart-updated', function(){
    var badge = document.querySelector('[data-cart-bubble]');
    if(badge && !reduce){
      badge.classList.remove('hmf-badge-pop');
      void badge.offsetWidth;
      badge.classList.add('hmf-badge-pop');
      setTimeout(function(){ badge.classList.remove('hmf-badge-pop'); }, 600);
    }
    // The in-page button is rebuilt by renderBuybox() after 1600ms, which drops
    // the class on its own; the bar's button is not, so it is cleared by hand.
    [realBtn(), elBtn].forEach(function(b){
      if(!b) return;
      b.classList.add('hmf-atc-done');
      setTimeout(function(){ b.classList.remove('hmf-atc-done'); }, 1650);
    });
    queueSync();
  });
})();
